import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AddVendorItemAliasMutationVariables = Types.Exact<{
  input: Types.AddVendorItemAliasInput;
}>;


export type AddVendorItemAliasMutation = { __typename?: 'Mutation', addVendorItemAlias: { __typename?: 'VendorItemAliasPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, typedErrors?: { __typename?: 'VendorItemAliasTypedErrors', collision?: { __typename?: 'VendorItemAliasCollision', aliasId: string, materialItemId: string } | null } | null, vendorItemAlias?: { __typename?: 'VendorItemAlias', aliasId: string, vendorId: string, materialItemId: string, supplierItemId?: string | null, supplierDescription?: string | null, manufacturerKey?: string | null, status: Types.VendorItemAliasStatus, source: Types.VendorItemAliasSource, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, replacedByAliasId?: string | null, version: number, createdAt: Types.TDateISO, retiredAt?: Types.TDateISO | null } | null } };

export type RetireVendorItemAliasMutationVariables = Types.Exact<{
  input: Types.RetireVendorItemAliasInput;
}>;


export type RetireVendorItemAliasMutation = { __typename?: 'Mutation', retireVendorItemAlias: { __typename?: 'VendorItemAliasPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorItemAlias?: { __typename?: 'VendorItemAlias', aliasId: string, vendorId: string, materialItemId: string, supplierItemId?: string | null, supplierDescription?: string | null, manufacturerKey?: string | null, status: Types.VendorItemAliasStatus, source: Types.VendorItemAliasSource, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, replacedByAliasId?: string | null, version: number, createdAt: Types.TDateISO, retiredAt?: Types.TDateISO | null } | null } };


export const AddVendorItemAliasDocument = new TypedDocumentString(`
    mutation AddVendorItemAlias($input: AddVendorItemAliasInput!) {
  addVendorItemAlias(input: $input) {
    errors {
      code
      message
    }
    typedErrors {
      collision {
        aliasId
        materialItemId
      }
    }
    vendorItemAlias {
      ...VendorItemAlias
    }
  }
}
    fragment VendorItemAlias on VendorItemAlias {
  aliasId
  vendorId
  materialItemId
  supplierItemId
  supplierDescription
  manufacturerKey
  status
  source
  effectiveFrom
  effectiveUntil
  replacedByAliasId
  version
  createdAt
  retiredAt
}`);
export const RetireVendorItemAliasDocument = new TypedDocumentString(`
    mutation RetireVendorItemAlias($input: RetireVendorItemAliasInput!) {
  retireVendorItemAlias(input: $input) {
    errors {
      code
      message
    }
    vendorItemAlias {
      ...VendorItemAlias
    }
  }
}
    fragment VendorItemAlias on VendorItemAlias {
  aliasId
  vendorId
  materialItemId
  supplierItemId
  supplierDescription
  manufacturerKey
  status
  source
  effectiveFrom
  effectiveUntil
  replacedByAliasId
  version
  createdAt
  retiredAt
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddVendorItemAlias: build.mutation<AddVendorItemAliasMutation, AddVendorItemAliasMutationVariables>({
      query: (variables) => ({ document: AddVendorItemAliasDocument, variables })
    }),
    RetireVendorItemAlias: build.mutation<RetireVendorItemAliasMutation, RetireVendorItemAliasMutationVariables>({
      query: (variables) => ({ document: RetireVendorItemAliasDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddVendorItemAliasMutation, useRetireVendorItemAliasMutation } = injectedRtkApi;
